export default __webpack_public_path__ + "static/media/PEAR.bbd08a00.svg";